export default function () {
  return {
    year: "2024",
    semester: "2",
    lock_: true,
    //
  }
}
